function handleBSCard() {
  // Handle BS cards
  const bsCards = $("[data-custom-products] .bs-product-card-v2__card");
  handleCards(bsCards, false);

  // Handle Sale cards
  const saleCards = $("[data-sale-products] .bs-product-card-v2__card");
  handleCards(saleCards, true);

  // Handle frame size clicks for BS cards
  handleBSFrameSizeClicks();

  // Initialize frame size states
  initializeBSFrameSizeStates();
}

function handleCards(cards, isSale) {
  cards.each(function () {
    const $card = $(this);
    const $addToCartBtn = $card.find("#is-bs-product-atc-btn");
    const $sideShieldToggleInput = $card.find(
      ".is-bs-product-sideshield-toggle",
    );
    const $productImage = $card.find(
      ".bs-product-card-v2__card-image:not(#is-bs-product-shield-image)",
    );
    const $sideShieldImage = $card.find("#is-bs-product-shield-image");
    const $currentPriceElem = $card.find("#is-bs-product-price");
    const $reviewLink = $card.find("#sandlane-main-review-widget");
    const $productLink = $card.find(
      ".bs-product-card-v2__card-image-wrapper a",
    );
    const $alertMessage = $card.find(".custom-alert-message");

    const currentPrice = isSale
      ? $card.attr("data-sale-variant-price")
      : $card.attr("data-bs-variant-price");
    const sideShieldPrice = isSale
      ? $card.attr("data-sale-side-shield-price")
      : $card.attr("data-bs-side-shield-price");
    const productId = isSale
      ? $card.attr("data-sale-product-id")
      : $card.attr("data-bs-product-id");
    const sideShieldId = isSale
      ? $card.attr("data-sale-side-shield-id")
      : $card.attr("data-bs-side-shield-id");

    let isSideShieldEnabled = false;

    function updatePrice(isShieldEnabled) {
      // Get current base prices from data attributes (may have been updated by frame size selection)
      const basePrice =
        parseInt($card.attr("data-bs-variant-price")) ||
        parseInt(currentPrice) ||
        0;
      const shieldPrice = parseInt(sideShieldPrice) || 0;

      // Calculate new price
      const newPrice = isShieldEnabled ? basePrice + shieldPrice : basePrice;

      // Update sale price
      $currentPriceElem.find(".bfcm-sale-price").text("$" + newPrice);

      // Check if compare at price element exists
      const $comparePrice = $currentPriceElem.find(".bfcm-compare-at-price");
      if ($comparePrice.length > 0) {
        const originalComparePrice =
          parseInt($card.attr("data-bs-variant-compare-price")) ||
          parseInt($card.attr("data-bs-variant-compare-price")) ||
          basePrice;
        const originalShieldComparePrice =
          parseInt($card.attr("data-bs-side-shield-compare-price")) ||
          shieldPrice;

        // Calculate total compare at price including side shields if enabled
        const totalComparePrice = isShieldEnabled
          ? originalComparePrice + originalShieldComparePrice
          : originalComparePrice;

        if (totalComparePrice > newPrice) {
          $comparePrice.text("$" + totalComparePrice + " ");
        }
      }
    }

    function toggleImages(isShieldEnabled) {
      if (isShieldEnabled) {
        // Check if side shield image exists and has valid src
        const hasValidShieldImage =
          $sideShieldImage.length > 0 &&
          $sideShieldImage.attr("src") &&
          $sideShieldImage.attr("src").trim() !== "";

        if (!hasValidShieldImage) {
          // Show alert message if no valid side shield image
          $alertMessage.removeClass("hide-this");
          $productImage.removeClass("hide-this");
          $sideShieldImage.addClass("hide-this");
        } else {
          // Hide main image and show side shield image
          $productImage.addClass("hide-this");
          $sideShieldImage.removeClass("hide-this");
          $alertMessage.addClass("hide-this");
        }
      } else {
        // Reset to original state
        $productImage.removeClass("hide-this");
        $sideShieldImage.addClass("hide-this");
        $alertMessage.addClass("hide-this");
      }
    }

    function updateLinks(isShieldEnabled) {
      const linksToUpdate = [$reviewLink, $productLink];

      linksToUpdate.forEach(($link) => {
        if ($link.length) {
          let href = $link.attr("href");

          if (href.includes("#")) {
            const [mainUrl, hashPart] = href.split("#");
            const urlParts = mainUrl.split("?");
            const baseUrl = urlParts[0];
            const params = new URLSearchParams(urlParts[1]);

            if (isShieldEnabled) {
              params.set("addons", "sideshields");
            } else {
              params.delete("addons");
            }

            href = `${baseUrl}${
              params.toString().length > 0 ? "?" + params.toString() : ""
            }#${hashPart}`;
          } else {
            const urlParts = href.split("?");
            const baseUrl = urlParts[0];
            const params = new URLSearchParams(urlParts[1]);

            if (isShieldEnabled) {
              params.set("addons", "sideshields");
            } else {
              params.delete("addons");
            }

            href = `${baseUrl}${
              params.toString().length > 0 ? "?" + params.toString() : ""
            }`;
          }

          $link.attr("href", href);
        }
      });
    }

    $sideShieldToggleInput.on("change", function () {
      const $this = $(this);
      const cardType = $this.data("card-type");
      const variantId = $this.data("variant-id");

      // Only handle if it matches the card type
      if (
        (isSale && cardType === "sale") ||
        (!isSale && cardType === "bestseller")
      ) {
        isSideShieldEnabled = $this.is(":checked");
        toggleImages(isSideShieldEnabled);
        updatePrice(isSideShieldEnabled);
        updateLinks(isSideShieldEnabled);
      }
    });

    $addToCartBtn.on("click", async function () {
      // Check if this is a Klaviyo back-in-stock trigger
      if ($(this).hasClass("klaviyo-collection-bis-trigger")) {
        // Prevent SLIDE CART from opening
        window.SLIDECART_OPENED = false;

        // Let the Klaviyo handler take care of this
        return;
      }

      try {
        // Get current product ID (may have been updated by frame size selection)
        const currentProductId = $card.attr("data-bs-product-id") || productId;
        const items = isSideShieldEnabled
          ? [{ id: currentProductId }, { id: sideShieldId }]
          : [{ id: currentProductId }];

        await OmbrazUtils.v2AddToCart(items, { button: this });
      } catch (error) {
        console.error("Error adding to cart:", error);
      }
    });
  });
}

function initializeBSFrameSizeStates() {
  // Initialize add to cart button states based on active frame size
  const bsCards = document.querySelectorAll(
    "[data-custom-products] .bs-product-card-v2__card",
  );

  bsCards.forEach((card) => {
    const activeFrameButton = card.querySelector(
      ".bs-product-card-v2__frame-size-btn.is-active",
    );
    const addToCartButton = card.querySelector("#is-bs-product-atc-btn");

    if (activeFrameButton && addToCartButton) {
      const variantId = activeFrameButton.dataset.variantId;
      const isAvailable = activeFrameButton.dataset.available === "true";
      const hasNoVariant = activeFrameButton.dataset.noVariant === "true";

      if (hasNoVariant || !variantId) {
        addToCartButton.disabled = false;
        addToCartButton.textContent = "Notify when in stock";
        addToCartButton.classList.add("klaviyo-collection-bis-trigger");

        // Add BIS data attributes for Klaviyo (use card's current product ID as fallback)
        const currentProductId = card.getAttribute("data-bs-product-id");
        const cardTitle =
          card.closest(".bs-product-card-v2__list-item")?.querySelector("h2")
            ?.textContent || "";
        const frameColorSpan = card.querySelector(
          ".bs-product-card-v2__card-title-group p span:first-child",
        );
        const lensTypeSpan = card.querySelector(
          ".bs-product-card-v2__card-title-group p span:last-child",
        );
        const frameColor = frameColorSpan?.textContent || "";
        let lensType =
          lensTypeSpan?.dataset.rawLensTitle || lensTypeSpan?.textContent || "";
        if (lensType === "Blue-Blocking") {
          lensType = "Low Light";
        }
        // Get frame size from active frame button
        const activeFrameButton = card.querySelector(
          ".bs-product-card-v2__frame-size-btn.is-active",
        );
        const frameSize = activeFrameButton?.dataset?.frameSize || "";
        const productTitle =
          frameColor && lensType
            ? frameSize
              ? `${cardTitle} / ${frameColor} / ${lensType} / ${frameSize}`
              : `${cardTitle} / ${frameColor} / ${lensType}`
            : cardTitle;
        addToCartButton.setAttribute(
          "data-variant",
          currentProductId || variantId,
        );
        addToCartButton.setAttribute("data-product-name", productTitle);
        addToCartButton.setAttribute(
          "data-product-id",
          currentProductId || variantId,
        );
      } else if (isAvailable) {
        addToCartButton.disabled = false;
        addToCartButton.textContent = "Add to Cart";
        addToCartButton.classList.remove("klaviyo-collection-bis-trigger");
        // Update the card's data-bs-product-id to match the active frame size
        card.setAttribute("data-bs-product-id", variantId);
      } else {
        addToCartButton.disabled = false;
        addToCartButton.textContent = "Notify when in stock";
        addToCartButton.classList.add("klaviyo-collection-bis-trigger");
        // Update the card's data-bs-product-id to match the active frame size
        card.setAttribute("data-bs-product-id", variantId);

        // Add BIS data attributes for Klaviyo
        const cardTitle =
          card.closest(".bs-product-card-v2__list-item")?.querySelector("h2")
            ?.textContent || "";
        const frameColorSpan = card.querySelector(
          ".bs-product-card-v2__card-title-group p span:first-child",
        );
        const lensTypeSpan = card.querySelector(
          ".bs-product-card-v2__card-title-group p span:last-child",
        );
        const frameColor = frameColorSpan?.textContent || "";
        let lensType =
          lensTypeSpan?.dataset.rawLensTitle || lensTypeSpan?.textContent || "";
        if (lensType === "Blue-Blocking") {
          lensType = "Low Light";
        }
        const productTitle =
          frameColor && lensType
            ? frameSize
              ? `${cardTitle} / ${frameColor} / ${lensType} / ${frameSize}`
              : `${cardTitle} / ${frameColor} / ${lensType}`
            : cardTitle;
        addToCartButton.setAttribute("data-variant", variantId);
        addToCartButton.setAttribute("data-product-name", productTitle);
        addToCartButton.setAttribute("data-product-id", variantId);
      }
    }
  });
}

function handleBSFrameSizeClicks() {
  // Handle frame size button clicks for bestseller cards
  const frameSizeButtons = document.querySelectorAll(
    ".bs-product-card-v2__frame-size-btn",
  );

  if (!frameSizeButtons || frameSizeButtons.length === 0) {
    return;
  }

  frameSizeButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const card = this.closest(".bs-product-card-v2__card");
      if (!card) return;

      const cardButtons = card.querySelectorAll(
        ".bs-product-card-v2__frame-size-btn",
      );

      // Remove active class from all buttons in this card
      cardButtons.forEach((btn) => {
        btn.classList.remove("is-active");
        btn.setAttribute("aria-pressed", "false");
      });

      // Add active class to clicked button
      this.classList.add("is-active");
      this.setAttribute("aria-pressed", "true");

      // Update product state (variant ID, pricing, etc)
      updateBSProductState(card);
    });
  });
}

function updateBSProductState(productCard) {
  if (!productCard) return;

  const selectedButton = productCard.querySelector(
    ".bs-product-card-v2__frame-size-btn.is-active",
  );
  const addToCartButton = productCard.querySelector("#is-bs-product-atc-btn");
  const productImageWrapper = productCard.querySelector(
    ".bs-product-card-v2__card-image-wrapper a",
  );
  const cardTitleLink = productCard.querySelector(
    ".bs-product-card-v2__card-title-group",
  );
  const reviewLink = productCard.querySelector(".klaviyo-star-rating-wrapper");

  if (!selectedButton) return;

  const variantId = selectedButton.dataset?.variantId;
  const frameSize = selectedButton.dataset?.frameSize;
  const isAvailable = selectedButton.dataset?.available === "true";
  const hasNoVariant = selectedButton.dataset?.noVariant === "true";

  // If button has no variant, disable add to cart
  if (hasNoVariant || !variantId) {
    if (addToCartButton) {
      addToCartButton.disabled = true;
      addToCartButton.textContent = "Unavailable";
    }
    return;
  }

  // Update add to cart button with new variant ID
  if (addToCartButton && variantId) {
    productCard.setAttribute("data-bs-product-id", variantId);

    if (isAvailable) {
      addToCartButton.disabled = false;
      addToCartButton.textContent = "Add to Cart";
      addToCartButton.classList.remove("klaviyo-collection-bis-trigger");
      // Remove BIS data attributes when in stock
      addToCartButton.removeAttribute("data-variant");
      addToCartButton.removeAttribute("data-product-name");
      addToCartButton.removeAttribute("data-product-id");
    } else {
      addToCartButton.disabled = false;
      addToCartButton.textContent = "Notify when in stock";
      addToCartButton.classList.add("klaviyo-collection-bis-trigger");

      // Add BIS data attributes for Klaviyo
      const cardTitle =
        productCard
          .closest(".bs-product-card-v2__list-item")
          ?.querySelector("h2")?.textContent || "";
      const frameColorSpan = productCard.querySelector(
        ".bs-product-card-v2__card-title-group p span:first-child",
      );
      const lensTypeSpan = productCard.querySelector(
        ".bs-product-card-v2__card-title-group p span:last-child",
      );
      const frameColor = frameColorSpan?.textContent || "";
      let lensType =
        lensTypeSpan?.dataset.rawLensTitle || lensTypeSpan?.textContent || "";
      if (lensType === "Blue-Blocking") {
        lensType = "Low Light";
      }
      const productTitle =
        frameColor && lensType
          ? frameSize
            ? `${cardTitle} / ${frameColor} / ${lensType} / ${frameSize}`
            : `${cardTitle} / ${frameColor} / ${lensType}`
          : cardTitle;
      addToCartButton.setAttribute("data-variant", variantId);
      addToCartButton.setAttribute("data-product-name", productTitle);
      addToCartButton.setAttribute("data-product-id", variantId);
    }
  }

  // Update pricing
  if (variantId) {
    updateBSRegularPricing(productCard, selectedButton);
  }

  // Update product links with selected variant parameter
  if (productImageWrapper && variantId) {
    let href = productImageWrapper.getAttribute("href");

    if (href.includes("#")) {
      const [mainUrl, hashPart] = href.split("#");
      const urlParts = mainUrl.split("?");
      const baseUrl = urlParts[0];
      const params = new URLSearchParams(urlParts[1]);

      params.set("variant", variantId);

      href = `${baseUrl}?${params.toString()}#${hashPart}`;
    } else {
      const urlParts = href.split("?");
      const baseUrl = urlParts[0];
      const params = new URLSearchParams(urlParts[1]);

      params.set("variant", variantId);

      href = `${baseUrl}?${params.toString()}`;
    }

    productImageWrapper.setAttribute("href", href);
  }

  // Update card title link
  if (cardTitleLink && variantId) {
    let href = cardTitleLink.getAttribute("href");

    if (href.includes("#")) {
      const [mainUrl, hashPart] = href.split("#");
      const urlParts = mainUrl.split("?");
      const baseUrl = urlParts[0];
      const params = new URLSearchParams(urlParts[1]);

      params.set("variant", variantId);

      href = `${baseUrl}?${params.toString()}#${hashPart}`;
    } else {
      const urlParts = href.split("?");
      const baseUrl = urlParts[0];
      const params = new URLSearchParams(urlParts[1]);

      params.set("variant", variantId);

      href = `${baseUrl}?${params.toString()}`;
    }

    cardTitleLink.setAttribute("href", href);
  }

  // Update review link
  if (reviewLink && variantId) {
    let href = reviewLink.getAttribute("href");

    if (href.includes("#")) {
      const [mainUrl, hashPart] = href.split("#");
      const urlParts = mainUrl.split("?");
      const baseUrl = urlParts[0];
      const params = new URLSearchParams(urlParts[1]);

      params.set("variant", variantId);

      href = `${baseUrl}?${params.toString()}#${hashPart}`;
    } else {
      const urlParts = href.split("?");
      const baseUrl = urlParts[0];
      const params = new URLSearchParams(urlParts[1]);

      params.set("variant", variantId);

      href = `${baseUrl}?${params.toString()}`;
    }

    reviewLink.setAttribute("href", href);
  }
}

function updateBSRegularPricing(productCard, selectedButton) {
  if (!productCard || !selectedButton) return;

  // Get variant price from button data attributes
  const variantPrice = parseInt(selectedButton.dataset.variantPrice);
  const variantComparePrice =
    parseInt(selectedButton.dataset.variantComparePrice) || 0;

  if (!variantPrice) {
    return;
  }

  // Update price display
  const priceElement = productCard.querySelector("#is-bs-product-price");
  if (priceElement) {
    const salePriceElement = priceElement.querySelector(".bfcm-sale-price");
    const comparePriceElement = priceElement.querySelector(
      ".bfcm-compare-at-price",
    );

    if (salePriceElement) {
      salePriceElement.textContent = "$" + variantPrice;
    }

    if (comparePriceElement) {
      if (variantComparePrice > variantPrice) {
        comparePriceElement.textContent = "$" + variantComparePrice + " ";
        comparePriceElement.style.display = "";
      } else {
        comparePriceElement.style.display = "none";
      }
    }
  }

  // Update data attributes for side shield calculations
  productCard.setAttribute("data-bs-variant-price", variantPrice);
  if (variantComparePrice > 0) {
    productCard.setAttribute(
      "data-bs-variant-compare-price",
      variantComparePrice,
    );
  }
}

$(document).ready(handleBSCard);
